import { EventEmitter, Injectable } from '@angular/core'
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { ISystemInfoModel } from '../../../models/system-info.model'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class SystemInfoService {
  private apiURL: string = environment.apiUrl + '/system-info'
  private _changeEvent: EventEmitter<boolean> = new EventEmitter<boolean>()

  public get changeEvent(): EventEmitter<boolean> {
    return this._changeEvent
  }

  constructor(private http: HttpClient) {}

  public getSystemInfo(): Observable<ISystemInfoModel> {
    const url = this.apiURL
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((resource: ISystemInfoModel) => {
        return resource
      }),
    )
  }

  public updateSystemInfo(data: {
    company: string | null
    plant: string | null
    plant_lat: string | null
    plant_long: string | null
    plant_ship_heading: number | null
  }): Observable<any> {
    const url = this.apiURL
    return this.http.put(url, data, { headers: this.getHeaders() }).pipe(
      map((resource: any) => {
        return resource
      }),
    )
  }

  public uploadLogo(file: File) {
    const formData: FormData = new FormData()
    formData.append('file', file)
    const url = this.apiURL + '/upload/logo'
    return this.http
      .post(url, formData, { reportProgress: true, observe: 'events' })
      .pipe(map(event => this.handleEventMessage(event)))
  }

  public uploadIcon(file: File) {
    const formData: FormData = new FormData()
    formData.append('file', file)
    const url = this.apiURL + '/upload/icon'
    return this.http
      .post(url, formData, { reportProgress: true, observe: 'events' })
      .pipe(map(event => this.handleEventMessage(event)))
  }

  private handleEventMessage(event: HttpEvent<any>) {
    switch (event.type) {
      case HttpEventType.DownloadProgress:
      case HttpEventType.UploadProgress:
        return this.fileUploadProgress(event)
      case HttpEventType.Response:
        return this.apiResponse(event)
      default:
        return `Unknown event type`
    }
  }

  private fileUploadProgress(event: any) {
    const percent = Math.round((100 * event.loaded) / event.total)
    return { status: 'Progress', message: percent }
  }

  private apiResponse(event: any) {
    return event.body
  }

  private getHeaders() {
    return new HttpHeaders().set('Content-Type', 'application/json')
  }
}
